import { profileFeatureConfig as base } from './base';
import { profileFeatureConfig as AT } from './AT';

export const profileFeatureConfig = {
    base,
    AT,
};
